import { OrderPaymentDto } from '@up/data';

export class FireOpenOrderPaymentResponse {
  message?: string;
  success: boolean;
  orderPaymentDto?: OrderPaymentDto;
  code?: string;
}
